import { render, staticRenderFns } from "./GameProperties.vue?vue&type=template&id=68f4f93c&scoped=true&"
import script from "./GameProperties.vue?vue&type=script&lang=js&"
export * from "./GameProperties.vue?vue&type=script&lang=js&"
import style0 from "./GameProperties.vue?vue&type=style&index=0&id=68f4f93c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f4f93c",
  null
  
)

export default component.exports